import { render, staticRenderFns } from "./store-items-filters.vue?vue&type=template&id=1d482b06&scoped=true"
import script from "./store-items-filters.vue?vue&type=script&lang=js"
export * from "./store-items-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d482b06",
  null
  
)

export default component.exports